import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import nl from './locales/nl.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import sv from './locales/sv.json';
import zh from './locales/zh.json';
import cs from './locales/cs.json';
import ro from './locales/ro.json';
import fi from './locales/fi.json';
import pl from './locales/pl.json';
import da from './locales/da.json';

const lang = new URLSearchParams(window.location.search).get('lang');

void i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      es: { translation: es },
      fr: { translation: fr },
      it: { translation: it },
      ja: { translation: ja },
      nl: { translation: nl },
      pt: { translation: pt },
      ru: { translation: ru },
      sv: { translation: sv },
      zh: { translation: zh },
      cs: { translation: cs },
      ro: { translation: ro },
      fi: { translation: fi },
      pl: { translation: pl },
      da: { translation: da },
    },
    lng: lang ?? undefined,
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'es', 'fr', 'it', 'ja', 'nl', 'pt', 'ru', 'sv', 'zh', 'cs', 'ro', 'fi', 'pl', 'da'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['navigator'],
      caches: [],
    },
    react: { useSuspense: true },
  });
